// The video editor's text strings (components/Editor), under t('editor.rve.text.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  transcript: {
    heading: 'Transcripción',
    wordsOne: '{n} palabra',
    wordsMany: '{n} palabras',
    seconds: '{n} s',
    minutes: '{m} min {s} s',
    editWord: 'Editar palabra',
    noPauses: 'Este clip no tiene pausas largas.',
    cutSpeaker: 'Quitar todo lo que dice {name} ({n} palabras)',
    speakerMenu: '{name}: lo que dice',
    cantListen: 'No se pudo escuchar el sonido de este clip. Inténtalo de nuevo en un momento.',
    emptyTitle: 'No hay transcripción para editar',
    emptyBody: 'La transcripción sale de los subtítulos de este video. Agrega subtítulos y sus palabras aparecen aquí: corta una palabra y se corta del video.',
    removeFillersTitle: 'Corta cada «eh», «em» y «mmm»',
    removeFillers: 'Quitar muletillas ({n})',
    removePausesTitleClip: 'Escucha el clip y acorta cada silencio de más de 0.6 s',
    removePausesTitle: 'Acorta cada silencio de más de 0.7 s',
    listening: 'Buscando las pausas…',
    removePauses: 'Quitar pausas',
    removePausesCount: 'Quitar pausas ({n} · {duration})',
    emphasizeTitle: 'Las palabras clave se quedan con el color de resaltado de los subtítulos',
    unmark: 'Desmarcar',
    emphasize: 'Resaltar',
    cut: 'Cortar',
    clearSelection: 'Quitar selección',
    hintTitle: 'Haz clic en una palabra para ir a ella · Mayús+clic o arrastra para seleccionar · Suprimir corta la selección · doble clic en una palabra para corregirla',
    hint: "Clic para ir · {key} corta · doble clic para corregir",
    deleteKey: "Supr",
    nothingToRemove: "No hay muletillas ni pausas largas que quitar.",
    hintTouch: "Toca una palabra para seleccionarla · córtala o corrígela desde la barra",
    fixWord: "Corregir",
  },

  transcribe: {
    uploadedVideo: 'Video subido',
    jobTitle: 'Subtítulos · {name}',
    video: 'video',
    transcribe: 'Transcribir',
    carriesOn: '{step}… sigue aunque cambies de panel.',
    dismiss: 'Cerrar',
    usesMinutes: 'Usa los minutos de tu plan, como Subtítulos automáticos. Los subtítulos quedan en la línea de tiempo, debajo del video.',
  },

  captions: {
    srtFailed: 'No se pudo leer el SRT: {n} error(es)',
    noCaptionsInSrt: 'No se encontraron subtítulos en el archivo SRT.',
    invalidJson: 'Formato JSON no válido. Se espera { words: [...] }',
    jsonFailed: 'No se pudo leer el archivo JSON. Revisa el formato.',
    textFailed: 'No se pudo leer el archivo de texto.',
    unsupported: 'Formato no compatible. Usa .srt, .json o .txt',
    line: 'Línea {n}',
    moreErrors: '...y {n} errores más',
    dismiss: 'Cerrar',
    processing: 'Procesando...',
    upload: 'Subir archivo de subtítulos',
    supported: 'Compatibles: .srt, .json, .txt',
    srtHelp: 'Los archivos SRT traen el tiempo exacto de cada subtítulo. Puedes exportar SRT desde casi cualquier herramienta de transcripción.',
    or: 'o',
    scriptPlaceholder: 'Escribe o pega tu guion aquí...',
    generate: 'Generar subtítulos',
    clear: 'Borrar',
    label: 'Subtítulos',
    seekTo: 'Ir a {time}',
    start: 'Inicio',
    end: 'Fin',
    textPlaceholder: 'Escribe el texto del subtítulo...',
  },

  srt: {
    empty: 'El archivo está vacío',
    tooShort: 'Archivo demasiado corto: debe tener al menos un subtítulo',
    noTimestamps: 'No hay tiempos SRT válidos. Formato esperado: HH:MM:SS,mmm --> HH:MM:SS,mmm',
    badNumber: 'Número de subtítulo no válido: "{value}"',
    noTiming: 'Falta la línea de tiempo',
    badTiming: 'Formato de tiempo no válido: "{value}"',
    badTime: 'Tiempo no válido en el subtítulo {n}',
    startAfterEnd: 'El inicio debe ir antes del final en el subtítulo {n}',
    noText: 'El subtítulo {n} no tiene texto',
    emptyText: 'El texto del subtítulo {n} está vacío',
    blockFailed: 'No se pudo leer el bloque de subtítulo {n}',
    overlap: 'Los subtítulos {a} y {b} se superponen en el tiempo',
  },

  srtErrors: {
    title: 'No se pudo leer el archivo SRT',
    file: 'Archivo:',
    foundOne: 'Encontramos {n} error en el archivo SRT.',
    foundMany: 'Encontramos {n} errores en el archivo SRT.',
    fixAndRetry: 'Corrígelos e inténtalo de nuevo.',
    someSkipped: 'Puede que se hayan saltado algunos subtítulos.',
    validation: 'Error de validación',
    format: 'Error de formato',
    timing: 'Error de tiempos',
    encoding: 'Error de codificación',
    error: 'Error',
    solutionsTitle: 'Soluciones comunes:',
    solutions: [
      'Asegúrate de que tu archivo SRT siga el formato estándar',
      'Revisa que los tiempos usen el formato HH:MM:SS,mmm → HH:MM:SS,mmm',
      'Verifica que los números de subtítulo sean consecutivos',
      'Separa cada bloque de subtítulo con una línea en blanco',
      'Asegúrate de que cada inicio vaya antes de su final',
    ],
    expectedFormat: 'Formato SRT esperado:',
    tryAnother: 'Probar otro archivo',
  },

  captionStyle: {
    templates: {
      minimal: 'Minimal',
      neon: 'Neón',
      tiktok: 'TikTok',
      comic: 'Cómic',
      elegant: 'Elegante',
      glitch: 'Glitch',
      bold: 'Intenso',
      clean: 'Limpio',
      outline: 'Contorno',
    },
    cases: {
      normal: 'Normal',
      uppercase: 'MAYÚSCULAS',
      lowercase: 'minúsculas',
      capitalize: 'Tipo Título',
    },
    animations: {
      fade: 'Fundido',
      tiktok: 'TikTok',
      slide: 'Deslizar',
      pop: 'Pop',
      glitch: 'Glitch',
    },
    text: 'Texto',
    highlight: 'Resaltado',
    stroke: 'Borde',
    customize: 'Personalizar',
    position: 'Posición',
    fontAndText: 'Fuente y texto',
    fontPlaceholder: 'Fuente...',
    size: 'Tamaño',
    casePlaceholder: 'Mayúsculas...',
    outline: 'Borde',
    shadow: 'Sombra',
    background: 'Fondo',
    showBackground: 'Mostrar fondo',
    color: 'Color',
    opacity: 'Opacidad',
    animationAndTiming: 'Animación y ritmo',
    animationPlaceholder: 'Animación...',
    speed: 'Velocidad',
    highlightScale: 'Escala del resaltado ({n}%)',
    words: 'Palabras',
    spacing: 'Espaciado',
    lineHeight: 'Interlineado',
    letterSpacing: 'Espacio entre letras',
    normalSpacing: 'normal',
    transforms: 'Transformar',
    rotation: 'Rotación',
    skew: 'Inclinación',
    scale: 'Escala',
  },

  textPanel: {
    elements: 'Elementos',
    hookTitle: 'Título gancho',
    hookDefault: 'Espera…',
    hookOver: '«{text}» en los primeros 3 segundos',
    templates: {
      modern: { name: 'Título moderno', preview: 'Elegante y minimalista' },
      impact: { name: 'Frase de impacto', preview: 'Fuerte e imponente' },
      slicedText: { name: 'Texto cortado', preview: 'Atrevido y moderno' },
      minimalMonochrome: { name: 'Monocromo minimal', preview: 'Ultra minimalista' },
      highlight: { name: 'Caja resaltada', preview: 'Moderno y distinto' },
      gradient: { name: 'Degradado pop', preview: 'Dinámico y moderno' },
      neonFuture: { name: 'Neón futurista', preview: 'Eléctrico e intenso' },
      avantGarde: { name: 'Vanguardia', preview: 'A la moda' },
      glassmorphic: { name: 'Efecto vidrio', preview: 'Transparencia moderna' },
    },
  },

  textDetails: {
    preview: 'Vista previa del texto',
    placeholder: 'Escribe tu texto aquí...',
    settings: 'Ajustes',
    style: 'Estilo',
    typography: 'Tipografía',
    fontFamily: 'Fuente',
    selectFont: 'Elige una fuente',
    fonts: {
      sans: 'Inter (Sans serif)',
      serif: 'Merriweather (Serif)',
      mono: 'Roboto Mono (Monoespaciada)',
    },
    alignment: 'Alineación',
    alignLeft: 'Alinear a la izquierda',
    alignCenter: 'Centrar',
    alignRight: 'Alinear a la derecha',
    colors: 'Colores',
    textColor: 'Color del texto',
    highlight: 'Resaltado',
    gradientNoColors: 'Los colores no se pueden cambiar en los estilos de texto con degradado',
  },
};
